import React from 'react';
import { Button } from './ui/Button';
const testimonials = [{
  quote: 'Our Q&A sessions went from awkward silence to genuine engagement. Nexio helped us surface the questions attendees actually wanted to ask.',
  author: 'David Park',
  role: 'Conference Director at DevSummit',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80'
}, {
  quote: 'Managing our call for speakers used to be a nightmare of spreadsheets and emails. Nexio made it transparent, organized, and actually enjoyable.',
  author: 'Lisa Chen',
  role: 'Event Manager at Design Week',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80'
}, {
  quote: 'Letting our community vote on session topics was a game-changer. Attendance doubled for community-chosen workshops compared to organizer-selected ones.',
  author: 'Marcus Thompson',
  role: 'Founder of StartupCon',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80'
}];
export function Testimonials() {
  return <section className="py-20 bg-[#F5E6F5]" data-id="element-526">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-527">
        <div className="text-center mb-16" data-id="element-528">
          <span className="inline-block px-4 py-1 bg-white text-[#9333EA] text-sm font-medium rounded-full mb-4 border border-[#9333EA] shadow-sm" data-id="element-529">
            Testimonials
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-530">
            What event organizers say
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-531">
            See how conferences are creating more engaging experiences with
            Nexio App.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-532">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border-2 border-[#9333EA]" data-id="element-533">
              <div className="mb-4" data-id="element-534">
                <svg className="h-8 w-8 text-[#E5B3E5]" fill="currentColor" viewBox="0 0 32 32" data-id="element-535">
                  <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" data-id="element-536" />
                </svg>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg shadow-inner mb-4" data-id="element-537">
                <p className="text-gray-600 mb-2 italic" data-id="element-538">{testimonial.quote}</p>
              </div>
              <div className="flex items-center p-2 bg-white shadow-sm rounded-lg" data-id="element-539">
                <img src={testimonial.avatar} alt={testimonial.author} className="w-10 h-10 rounded-full mr-4 object-cover ring-2 ring-[#E5B3E5]/20" data-id="element-540" />
                <div data-id="element-541">
                  <p className="font-medium text-gray-900" data-id="element-542">
                    {testimonial.author}
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-543">{testimonial.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}